import React from 'react'
import AddManualAttendanceList from '../../../features/GMPCourseProvider/AddManualAttendanceList'

const AddManualAttendance = () => {
  return (
    <div>
      <AddManualAttendanceList />
    </div>
  )
}

export default AddManualAttendance
